<!-- START Search form -->
<card>
    <div class="card-header-content">
        <h1 *ngIf="view.searchForm">
            {{labels.staySearch}} <i class="fa fa-question-circle icon" (click)="toggleDescription()"></i>
            <div *ngIf="showDescription" class="field-description">
                <field-description [description]="formDescription"
                                   (clickOutside)="toggleDescription()"></field-description>
            </div>
        </h1>

        <h1 *ngIf="!view.searchForm">{{labels.searchSummary}}</h1>

        <div>
            <btn *ngIf="!this?.view?.loaders?.searchHotels && (this?.view?.hotelsList || (!view.searchForm && hotelsList?.length===0))"
                 class="search-ctn-edit-large"
                 type="actionHeaderLink"
                 [value]="view.searchForm ? labels.backToSummary : labels.editSearch"
                 (click)="switchView()">
            </btn>

            <btnForm *ngIf="view.searchForm && !view.resume"
                     class="search-ctn-edit-large"
                     styleType="actionHeaderLink"
                     (click)="search()">
                {{ labels.search }}
            </btnForm>
        </div>
    </div>

    <div class="card-body-content card-marge-inside">
        <notification *ngIf="error.active" [type]="error.type">{{ error.message }}</notification>
        <search-hotel-form #searchHotelForm *ngIf="!view.resume"
                           [request]="request"
                           (onSubmitForm)="onFormSubmitted($event)"></search-hotel-form>
        <resume *ngIf="view.resume" [resume]="request"></resume>
    </div>
</card>
<!-- END Search form -->

<!-- START Results list -->
<hotels-list *ngIf="(view.loaders.searchHotels || view.hotelsList) && configSharedHotel"
             [hotels]="hotelsList"
             [configSharedHotel]="configSharedHotel"
             [currencies]="currency"
             #hotelsListView>
</hotels-list>
<!-- END Results list -->
